import type { Translate } from '../../i18n'

/**
 * First two gateway names, then "and N more".
 *
 * Both the billers table and the edit form show a biller's gateways, and with
 * ~200 gateways on the platform a biller can hold enough of them that joining
 * every name breaks the row. One shared truncation so the two surfaces cannot
 * disagree; the full list lives on the Gateways screen filtered to the biller.
 */
export function truncateGatewayNames(names: readonly string[], t: Translate): string {
  const shown = names.slice(0, 2).join(', ')
  const rest = names.length - 2
  return rest > 0 ? `${shown} ${t('billers.gatewaysMore', { count: String(rest) })}` : shown
}
